/**
 * Names of the errors a request rejects with when it never got an HTTP response: fetch rejects
 * with a TypeError (network down, DNS, proxy, CORS), ky with a TimeoutError.
 */
var NETWORK_ERROR_NAMES = ["TypeError", "TimeoutError"];
/**
 * Tells a request that never reached the server apart from an HTTP error response (RCK-1657).
 *
 * @param error what a fetch/ky call rejected with, or a Response
 * @returns true when no HTTP response came back
 */
export var isNetworkError = function (error) {
    if (!error || typeof error !== "object") {
        return false;
    }
    var _a = error, name = _a.name, response = _a.response, status = _a.status;
    if (typeof status === "number" || response) {
        return false;
    }
    return (error instanceof TypeError ||
        (typeof name === "string" && NETWORK_ERROR_NAMES.includes(name)));
};
